module.exports = __webpack_public_path__ + "img/badge-list-thumb-052.5ed2a03f.png";